import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus.js';
/**
 * Sits at the top of the app shell and appears the moment the browser loses
 * its connection, so a failed action is never mistaken for a broken app.
 */
export function OfflineBanner({ message = "You're offline. We'll reconnect automatically.", }) {
    const online = useOnlineStatus();
    if (online)
        return null;
    return (_jsxs("div", { role: "status", "aria-live": "polite", className: "flex items-center justify-center gap-2 bg-navy px-4 py-2 text-center text-sm font-medium text-white", children: [_jsx(WifiOff, { "aria-hidden": "true", className: "h-4 w-4 shrink-0" }), message] }));
}
//# sourceMappingURL=OfflineBanner.js.map